import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import AdminAddTeams from "./AdminAddTeams";
import AdminVeteraniTeams from "./AdminVeteraniTeams";

const AdminAddTeamsContainer = ({ tournamentId, turnir }) => {
  const [activeTab, setActiveTab] = useState("seniori");
  const [isTeamsVisible, setIsTeamsVisible] = useState(false);
  const [hasVeterani, setHasVeterani] = useState(false);

  useEffect(() => {
    if (!tournamentId) return;

    supabase
      .from("admin_turniri")
      .select("prikazi_timove, features")
      .eq("id", tournamentId)
      .single()
      .then(({ data, error }) => {
        if (data) {
          setIsTeamsVisible(data.prikazi_timove);
          // Provjerava je li features objekt i da li je veterani true
          setHasVeterani(data.features?.veterani === true);
        } else if (error) {
          console.error("Greška kod dohvata postavki turnira:", error);
        }
      });
  }, [tournamentId]);

  // Funkcija za promjenu vidljivosti timova na webu za cijeli turnir
  const handleToggleVisibility = async (newValue) => {
    setIsTeamsVisible(newValue);
    const { error } = await supabase
      .from("admin_turniri")
      .update({ prikazi_timove: newValue })
      .eq("id", tournamentId);

    if (error) {
      console.error("Greška kod spremanja vidljivosti:", error);
      alert("Greška kod spremanja postavke na server.");
    }
  };

  return (
    <div className="admin-teams-wrapper">
      <div className="category-switcher-bar">
        <button
          className={`switcher-btn ${activeTab === "seniori" ? "active" : ""}`}
          onClick={() => setActiveTab("seniori")}
        >
          Seniori
        </button>
        {hasVeterani && (
          <button
            className={`switcher-btn ${activeTab === "veterani" ? "active" : ""}`}
            onClick={() => setActiveTab("veterani")}
          >
            Veterani
          </button>
        )}
      </div>

      {/* Kontrola vidljivosti timova na webu smještena centralno iznad sadržaja */}
      <div className="visibility-control-bar">
        <span
          className="control-label"
          style={{ color: "#fff", fontWeight: "600" }}
        >
          Prikaži timove na webu
        </span>
        <label className="ios-switch">
          <input
            type="checkbox"
            checked={isTeamsVisible}
            onChange={(e) => handleToggleVisibility(e.target.checked)}
          />
          <span className="slider"></span>
        </label>
      </div>

      {/* Sadržaj ovisno o odabranoj kartici (Seniori / Veterani) */}
      <div className="category-content">
        {activeTab === "seniori" ? (
          <AdminAddTeams tournamentId={tournamentId} hideVisibilityBar={true} />
        ) : (
          <AdminVeteraniTeams
            tournamentId={tournamentId}
            turnir={turnir}
            hideVisibilityBar={true}
          />
        )}
      </div>
    </div>
  );
};

export default AdminAddTeamsContainer;
